// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


function useIsValid(address, selectedArea, displayNeighborhood, displayNeighborhoods, geocodingStatus) {
  switch (geocodingStatus) {
    case "NotCalled" :
    case "Called" :
      return;
    case "Error" :
      return {
        NAME: "Error",
        VAL: "There was an error validating the address. Please check Key Facts"
      };
    default:
      if (address === undefined) {
        return;
      }
      if (selectedArea === undefined) {
        return;
      }
      if (displayNeighborhood === undefined) {
        return;
      }
      let displayNeighborhoodId = displayNeighborhood.id;
      if (displayNeighborhoods.some(param => param.id === displayNeighborhoodId)) {
        return "Valid";
      } else {
        return {
          NAME: "Error",
          VAL: displayNeighborhood.label + ` is not a valid display neighborhood for ` + address + `, ` + selectedArea.label
        };
      }
  }
}

exports.useIsValid = useIsValid;
/* No side effect */
